/**
 * Generic guided-tour anchors for any Serenity grid and edit dialog.
 * A screen that already set data-tour (the sales list, journal vouchers, POS
 * checkout) keeps its own selectors. A list with New gets grid-new, grid-search,
 * and grid-grid. A read-only ledger has no New button, so it gets inquiry-search,
 * inquiry-grid, inquiry-columns, and inquiry-pager instead. An open dialog gets
 * dialog-form, dialog-tabs, and dialog-save.
 */

const gridRoot = ".s-DataGrid";
const dialogRoot = ".modal, .ui-dialog";

function inDialog(node: Element): boolean {
    return !!node.closest(dialogRoot);
}

function stamp(node: Element | null | undefined, name: string) {
    if (!node || node.getAttribute("data-tour"))
        return;
    node.setAttribute("data-tour", name);
}

function stampGrid(grid: Element) {
    if (inDialog(grid))
        return;
    const add = grid.querySelector(".add-button");
    if (add) {
        stamp(add, "grid-new");
        stamp(grid.querySelector(".s-QuickSearchInput"), "grid-search");
        stamp(grid.querySelector(".grid-container") ?? grid, "grid-grid");
        return;
    }
    // No New button: the inquiry tour stays on the list. The pager class is
    // s-SlickPager (Serenity SlickPager); the column titles are slick-header.
    stamp(grid.querySelector(".s-QuickSearchInput"), "inquiry-search");
    stamp(grid.querySelector(".grid-container") ?? grid, "inquiry-grid");
    stamp(grid.querySelector(".slick-header"), "inquiry-columns");
    stamp(grid.querySelector(".s-SlickPager"), "inquiry-pager");
}

function stampDialog(dialog: Element) {
    stamp(dialog.querySelector(".save-and-close-button"), "dialog-save");
    stamp(dialog.querySelector(".s-PropertyGrid, .categories"), "dialog-form");
    stamp(dialog.querySelector("ul.property-tabs"), "dialog-tabs");
}

export function stampTourAnchors(root: ParentNode = document) {
    root.querySelectorAll(gridRoot).forEach(stampGrid);
    root.querySelectorAll(dialogRoot).forEach(stampDialog);
}

function install() {
    stampTourAnchors(document);
    let scheduled = false;
    const observer = new MutationObserver(() => {
        if (scheduled)
            return;
        scheduled = true;
        queueMicrotask(() => {
            scheduled = false;
            stampTourAnchors(document);
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

if (document.body)
    install();
else
    document.addEventListener("DOMContentLoaded", install);
